import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { env } from '@amfam/environment';

import { UserNotificationsResponse } from './user-notifications.model';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationsService {
  private http = inject(HttpClient);

  getNotifications(): Observable<UserNotificationsResponse> {
    return this.http.get<UserNotificationsResponse>(`${env.userAccountApi}/notifications`);
  }
}
